import api from "../services/api";

export const createCompanySettings = async ({
  company_name,
  vat_number,
  vat_percent,
  base_cost_per_delivery, 
  postal_address,
  business_address,
  phone,
  email,
  currency = "BWP",
}) => {
  try {
    const response = await api.post(
      "/company-settings-management/create",
      {
        company_name,
        vat_number,
        vat_percent,
        base_cost_per_delivery,
        postal_address,
        business_address,
        phone,
        email,
        currency,
      }
    );

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        error: response.data?.error || "Unexpected server response",
      };
    }
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to create company settings",
    };
  }
};


export const fetchCompanySettings = async () => {
  try {
    const response = await api.get(
      "/company-settings-management"
    );

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Unexpected server response" };
    }
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to fetch company settings",
    };
  }
};



export const updateCompanySettings = async (companySettingsId, updates) => {
  try {
    const response = await api.put(
      `/company-settings-management/${companySettingsId}`,
      updates
    );

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Unexpected server response" };
    }
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to update company settings",
    };
  }
};


export const deleteCompanySettings = async (companySettingsId) => {
  try {
    const response = await api.delete(
      `/company-settings-management/${companySettingsId}`
    );

    if (response.status === 200 && response.data.success) {
      return {
        success: true,
        message: "Company settings deleted successfully",
      };
    } else {
      return { success: false, error: "Unexpected server response" };
    }
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to delete company settings",
    };
  }
};
